import { Directive, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { VariationAttribute } from 'ish-core/models/product-variation/variation-attribute.model';
import { VariationProduct } from 'ish-core/models/product/product.model';

@Directive({
  selector: '[customCreateFilter]',
})
export class CreateFilterDirective implements OnChanges {
  @Input() prod: VariationProduct[] = [];
  @Output() groupedProducts = new EventEmitter<{ [key: string]: string[] }>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.prod && this.prod) {
      this.createFilters(this.prod);
    }
  }

  createFilters(prod: VariationProduct[]) {
    const allVariations: VariationAttribute[] = prod.flatMap(product => product.variableVariationAttributes);
    const transformedObject = allVariations.reduce((acc: any, obj: VariationAttribute) => {
      const trimmedValue = obj.value.trim(); // Trim the value to remove any leading or trailing spaces
      acc[obj.name] = acc[obj.name] || new Set();
      acc[obj.name].add(trimmedValue);
      return acc;
    }, {});

    const grouped: { [key: string]: string[] } = {};
    Object.keys(transformedObject).forEach(key => {
      grouped[key] = Array.from(transformedObject[key]);
    });

    this.groupedProducts.emit(grouped);
  }
}
